import { render, staticRenderFns } from "./EntityViewConfiguration.vue?vue&type=template&id=cb6510ca&scoped=true"
import script from "./EntityViewConfiguration.vue?vue&type=script&lang=js"
export * from "./EntityViewConfiguration.vue?vue&type=script&lang=js"
import style0 from "./EntityViewConfiguration.vue?vue&type=style&index=0&id=cb6510ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6510ca",
  null
  
)

export default component.exports